import React from 'react';

/**
 * Memory Help Content
 */
const MemoryHelp: React.FC = () => {
  return (
    <>
      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Memory Analytics
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
          The Memory page tracks how your agents store and retrieve information. Monitor memory operations, analyze patterns, and detect potential memory leaks.
        </p>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Memory Types
        </h3>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; <span className="font-medium">Short-term</span>: Conversation context within a session</p>
          <p>&#8226; <span className="font-medium">Long-term</span>: Persistent information across sessions</p>
          <p>&#8226; <span className="font-medium">Episodic</span>: Specific event memories</p>
          <p>&#8226; <span className="font-medium">Semantic</span>: Factual knowledge and relationships</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Memory Operations
        </h3>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; <span className="font-medium">Store</span>: Writing new memories</p>
          <p>&#8226; <span className="font-medium">Retrieve</span>: Reading existing memories</p>
          <p>&#8226; <span className="font-medium">Update</span>: Modifying stored information</p>
          <p>&#8226; <span className="font-medium">Delete</span>: Removing memories</p>
          <p>&#8226; <span className="font-medium">Search</span>: Semantic memory queries</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Memory Metrics
        </h3>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; <span className="font-medium">Total Entries</span>: Number of stored memories</p>
          <p>&#8226; <span className="font-medium">Storage Size</span>: Total memory consumption</p>
          <p>&#8226; <span className="font-medium">Hit Rate</span>: Successful retrieval percentage</p>
          <p>&#8226; <span className="font-medium">Retrieval Latency</span>: Time to fetch memories</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Leak Detection
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
          Monitor memory growth over time. Alerts trigger when memory usage grows unexpectedly, indicating potential leaks in long-running agents.
        </p>
      </div>

    </>
  );
};

export default MemoryHelp;
